import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { applyNoIndexMeta } from "@/utils/seo";
import NotFound from "@/pages/notFound";

function ErrorBoundary() {
  const error = useRouteError();
  useEffect(() => {
    applyNoIndexMeta();
  }, []);

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFound />;
  }

  if (isRouteErrorResponse(error)) {
    return (
      <div>
        <h1>Oops!</h1>
        <h2>{error.status}</h2>
        <p>{error.statusText}</p>
        {error.data?.message && <p>{error.data.message}</p>}
      </div>
    );
  }

  return <NotFound />;
}

export default ErrorBoundary;
